<template>
  <!--
    全局轻提示 Toast（联鹿社区 H5 通用）
    调用：this.$toast(message, duration = 1500)
    样式沿用 topic-select-popup 内置 toast：黑底半透 / 白字 / 圆角 / 居中 / 淡入淡出
  -->
  <transition name="app-toast">
    <div v-if="visible" class="app-toast">
      <span class="app-toast__text">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppToast',
  data () {
    return {
      visible: false,
      message: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.app-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 9999;
  max-width: 80%;
  padding: 16px 28px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 12px;
  text-align: center;
  transform: translate(-50%, -50%);
}
.app-toast__text {
  font-size: 26px;
  color: #ffffff;
  line-height: 37px;
  word-break: break-all;
}
.app-toast-enter-active,
.app-toast-leave-active {
  transition: opacity 0.2s ease;
}
.app-toast-enter,
.app-toast-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/toast.vue